import React, { useEffect, useState } from 'react'
import "./style.scss"
import { subscribeNotificationUpdate } from '../../Events/utils.events'
import { cross } from '../../../../images/icon'

const NotificationWrapper = () => {
    const [notificationMessage, setNotificationMessageMessage] = useState(false)
    const handleNotificationMessage = (data) => {
        let message = data?.message
        setNotificationMessageMessage(message)
        setTimeout(() => {
            setNotificationMessageMessage(false)
        },10000)
    }
    useEffect(() => {
        subscribeNotificationUpdate(handleNotificationMessage)
    }, [])
    return (<>
        {notificationMessage ? <div className='notification-wrapper'>
            {notificationMessage}
        </div> : <></>}
    </>)
}

export default NotificationWrapper